export const QuizData = [
  {
    "id": "工作所屬產業",
    "set": "basic",
    "order": 1,
    "type": "select",
    "option": "industry",
    "title": "你的工作屬於哪個產業呢？",
    "description": "這邊列出的是勞基法裡面有特別寫出來的產業，有點眼花繚亂，但大部分人應該是「其他」吧",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "工作性質",
    "set": "",
    "order": 2,
    "type": "select",
    "option": "jobNature",
    "title": "工作本身有什麼特別的屬性嗎？",
    "description": "比方說， {TODO} 。一般沒有特別屬性的話，就是「連續性」囉！相關定義可參考： {TODO}",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "工作設定：酬勞計算基準",
    "set": "",
    "order": 3,
    "type": "select",
    "option": "wageBasis",
    "title": "你的薪水是怎麼算的呢？",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "工作設定：平日工資（金額，每月）",
    "set": "",
    "order": 4,
    "type": "input",
    "option": "",
    "title": "每個月的本薪是？",
    "description": "本薪指的是沒有獎金、也沒有扣除健保自付額、沒有經過任何加工計算的月薪。單位：新台幣",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "工作設定：平日工資（金額，每小時）",
    "set": "",
    "order": 5,
    "type": "input",
    "option": "",
    "title": "每個小時的時薪是？",
    "description": "加班的時候，每個小時的鐘點費是以多少錢計算呢？單位：新台幣",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "勞工：假日：休息日：給薪？",
    "set": "",
    "order": 6,
    "type": "select",
    "option": "boolean",
    "title": "休息日有算薪水嗎？",
    "description": "休息日指的是 {TODO}",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "勞工：假日：例假日：給薪？",
    "set": "",
    "order": 7,
    "type": "select",
    "option": "boolean",
    "title": "例假日有算薪水嗎？",
    "description": "例假日指的是 {TODO}",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "勞工：假日：國定假日：放假？",
    "set": "",
    "order": 8,
    "type": "select",
    "option": "boolean",
    "title": "國定假日有放假嗎？",
    "description": "所謂的國定假日，指的是勞動節、民間節日、國家紀念日，詳： {TODO}",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "勞工：假日：國定假日：給薪？",
    "set": "",
    "order": 9,
    "type": "select",
    "option": "boolean",
    "title": "國定假日有算薪水嗎？",
    "description": "所謂的國定假日，指的是勞動節、民間節日、國家紀念日，詳： {TODO}",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "勞工：假日：特別休假日：給薪？",
    "set": "",
    "order": 10,
    "type": "select",
    "option": "boolean",
    "title": "特別休假日有算薪水嗎？",
    "description": "特別休假日指的是 {TODO}",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "勞工：同一雇主繼續工作期間（滿年數）",
    "set": "",
    "order": 11,
    "type": "input",
    "option": "",
    "title": "你為同一個老闆工作滿幾年了呢？",
    "description": "只要是同一個老闆，不同公司也要算在一起喔",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "勞工：同一雇主繼續工作期間（滿月數）",
    "set": "",
    "order": 12,
    "type": "input",
    "option": "",
    "title": "承前一題，在做滿的年數之外，滿幾個月了呢？",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "勞工：同一雇主繼續工作期間（未滿月數）",
    "set": "",
    "order": 13,
    "type": "input",
    "option": "",
    "title": "承前一題，在做滿的年數之外，如果連沒做滿的月份一起算，是幾個月呢？",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "契約約期",
    "set": "",
    "order": 14,
    "type": "select",
    "option": "contractTerm",
    "title": "你的工作契約期間是怎麼定的呢？",
    "description": "沒特別註明期限的話，就是不定期囉",
    "next": "",
    "route": "個案：不定期契約停止履行？;個案：定期契約屆滿？;個案：不定期契約停止履行？",
    "logic": "",
    "rule": ""
  },
  {
    "id": "個案：定期契約屆滿？",
    "set": "",
    "order": 15,
    "type": "select",
    "option": "boolean",
    "title": "你約滿了嗎？",
    "description": "定期工作契約是不是到期了",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|fixed"
  },
  {
    "id": "個案：定期契約屆滿：繼續工作？",
    "set": "",
    "order": 16,
    "type": "select",
    "option": "boolean",
    "title": "約滿後，你有繼續為老闆工作嗎？",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|fixed;個案：定期契約屆滿？|==|true"
  },
  {
    "id": "個案：定期契約屆滿：繼續工作：雇主即反對？",
    "set": "",
    "order": 17,
    "type": "select",
    "option": "boolean",
    "title": "約滿後，你繼續為老闆工作，他有反對嗎？",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|fixed;個案：定期契約屆滿？|==|true;個案：定期契約屆滿：繼續工作？|==|true"
  },
  {
    "id": "個案：定期契約屆滿：另訂新約？",
    "set": "",
    "order": 18,
    "type": "select",
    "option": "boolean",
    "title": "約滿後，你跟老闆有另外簽新的工作契約嗎？",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|fixed;個案：定期契約屆滿？|==|true;"
  },
  {
    "id": "個案：定期契約屆滿：另訂新約：前後契約間斷期間（月數）",
    "set": "",
    "order": 19,
    "type": "input",
    "option": "",
    "title": "新約開始，跟舊約結束，中間隔了幾個月呢？",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|fixed;個案：定期契約屆滿？|==|true;個案：定期契約屆滿：另訂新約？|==|true"
  },
  {
    "id": "個案：定期契約屆滿：另訂新約：前後工作年資合併計算？",
    "set": "",
    "order": 20,
    "type": "select",
    "option": "boolean",
    "title": "新約開始後，你的年資有把舊約的年資也算進去嗎？",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|fixed;個案：定期契約屆滿？|==|true;個案：定期契約屆滿：另訂新約？|==|true"
  },
  {
    "id": "個案：定期契約屆滿：另訂新約：前後契約工作期間（日數）",
    "set": "",
    "order": 21,
    "type": "input",
    "option": "",
    "title": "新舊約都算的話，你總共工作了幾天呢？",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|fixed;個案：定期契約屆滿？|==|true;個案：定期契約屆滿：另訂新約？|==|true"
  },
  {
    "id": "個案：定期契約屆滿：另訂新約：前後契約間斷期間（日數）",
    "set": "",
    "order": 22,
    "type": "input",
    "option": "",
    "title": "新約開始，跟舊約結束，中間隔了幾天呢？",
    "description": "",
    "next": "勞工：假日：特別休假日（日數，每年）",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|fixed;個案：定期契約屆滿？|==|true;個案：定期契約屆滿：另訂新約？|==|true"
  },
  {
    "id": "個案：不定期契約停止履行？",
    "set": "",
    "order": 23,
    "type": "select",
    "option": "boolean",
    "title": "你離職了嗎？",
    "description": "不定期工作契約是不是終止了",
    "next": "",
    "route": ";勞工：假日：特別休假日（日數，每年）;勞工：假日：特別休假日（日數，每年）",
    "logic": "&&",
    "rule": "契約約期|==|non_fixed"
  },
  {
    "id": "個案：不定期契約停止履行：繼續履行原約？",
    "set": "",
    "order": 24,
    "type": "select",
    "option": "boolean",
    "title": "離職後，你有繼續為老闆工作嗎？",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|non_fixed;個案：不定期契約停止履行？|==|true"
  },
  {
    "id": "個案：不定期契約停止履行：繼續履行原約：前後契約間斷期間（月數）",
    "set": "",
    "order": 25,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|non_fixed;個案：不定期契約停止履行？|==|true;個案：不定期契約停止履行：繼續履行原約？|==|true"
  },
  {
    "id": "個案：不定期契約停止履行：繼續履行原約：前後工作年資合併計算？",
    "set": "",
    "order": 26,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|non_fixed;個案：不定期契約停止履行？|==|true;個案：不定期契約停止履行：繼續履行原約？|==|true"
  },
  {
    "id": "個案：不定期契約停止履行：另訂新約？",
    "set": "",
    "order": 27,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|non_fixed;個案：不定期契約停止履行？|==|true"
  },
  {
    "id": "個案：不定期契約停止履行：另訂新約：前後契約間斷期間（月數）",
    "set": "",
    "order": 28,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|non_fixed;個案：不定期契約停止履行？|==|true;個案：不定期契約停止履行：另訂新約？|==|true"
  },
  {
    "id": "個案：不定期契約停止履行：另訂新約：前後工作年資合併計算？",
    "set": "",
    "order": 29,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約約期|==|non_fixed;個案：不定期契約停止履行？|==|true;個案：不定期契約停止履行：另訂新約？|==|true"
  },
  {
    "id": "勞工：假日：特別休假日（日數，每年）",
    "set": "",
    "order": 30,
    "type": "input",
    "option": "",
    "title": "你今年有幾天特休呢？",
    "description": "",
    "next": "report",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "工作設定：工時制度",
    "set": "hours",
    "order": 31,
    "type": "select",
    "option": "workingHour",
    "title": "",
    "description": "",
    "next": "",
    "route": ";勞工：工會？;勞工：工會？;勞工：工會？;;",
    "logic": "",
    "rule": ""
  },
  {
    "id": "工作設定：工時制度：一般：正常工作時間（時數，每日）",
    "set": "",
    "order": 32,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|default"
  },
  {
    "id": "工作設定：工時制度：一般：正常工作時間（時數，每週）",
    "set": "",
    "order": 33,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|default"
  },
  {
    "id": "工作設定：工時制度：一般：例假（日數，每七日）",
    "set": "",
    "order": 34,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|default"
  },
  {
    "id": "工作設定：工時制度：一般：放假（日數，每七日）",
    "set": "",
    "order": 35,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "工作設定：工時制度：主管機關命令調整？",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|default"
  },
  {
    "id": "勞工：工會？",
    "set": "",
    "order": 36,
    "type": "select",
    "option": "boolean",
    "title": "公司的員工有組工會嗎？",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "工作設定：工時制度：兩週變形：指定行業？",
    "set": "",
    "order": 37,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_2w"
  },
  {
    "id": "工作設定：工時制度：兩週變形：工會同意？",
    "set": "",
    "order": 38,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_2w;勞工：工會？|==|true"
  },
  {
    "id": "工作設定：工時制度：兩週變形：勞資會議同意？",
    "set": "",
    "order": 39,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_2w"
  },
  {
    "id": "工作設定：工時制度：兩週變形：正常工作時間（時數，每週）",
    "set": "",
    "order": 40,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_2w"
  },
  {
    "id": "工作設定：工時制度：兩週變形：正常工作時間：自其他工作日分配（時數，每日）",
    "set": "",
    "order": 41,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_2w"
  },
  {
    "id": "工作設定：工時制度：兩週變形：正常工作時間：分配至其他工作日（日數，每二週）",
    "set": "",
    "order": 42,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_2w"
  },
  {
    "id": "工作設定：工時制度：兩週變形：例假（日數，每二週）",
    "set": "",
    "order": 43,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_2w"
  },
  {
    "id": "工作設定：工時制度：兩週變形：放假（日數，每二週）",
    "set": "",
    "order": 44,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "工作設定：工時制度：主管機關命令調整？",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_2w"
  },
  {
    "id": "工作設定：工時制度：八週變形：指定行業？",
    "set": "",
    "order": 45,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_8w"
  },
  {
    "id": "工作設定：工時制度：八週變形：工會同意？",
    "set": "",
    "order": 46,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_8w;勞工：工會？|==|true"
  },
  {
    "id": "工作設定：工時制度：八週變形：勞資會議同意？",
    "set": "",
    "order": 47,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_8w"
  },
  {
    "id": "工作設定：工時制度：八週變形：正常工作時間（時數，每日）",
    "set": "",
    "order": 48,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_8w"
  },
  {
    "id": "工作設定：工時制度：八週變形：正常工作時間（時數，每週）",
    "set": "",
    "order": 49,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_8w"
  },
  {
    "id": "工作設定：工時制度：八週變形：放假（日數，每八週）",
    "set": "",
    "order": 50,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "工作設定：工時制度：主管機關命令調整？",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_8w"
  },
  {
    "id": "工作設定：工時制度：四週變形：指定行業？",
    "set": "",
    "order": 51,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_4w"
  },
  {
    "id": "工作設定：工時制度：四週變形：工會同意？",
    "set": "",
    "order": 52,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_4w;勞工：工會？|==|true"
  },
  {
    "id": "工作設定：工時制度：四週變形：勞資會議同意？",
    "set": "",
    "order": 53,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_4w"
  },
  {
    "id": "工作設定：工時制度：四週變形：正常工作時間（時數，每日）",
    "set": "",
    "order": 54,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_4w"
  },
  {
    "id": "工作設定：工時制度：四週變形：正常工作時間：自其他工作日分配（時數，每日）",
    "set": "",
    "order": 55,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_4w"
  },
  {
    "id": "工作設定：工時制度：四週變形：放假（日數，每四週）",
    "set": "",
    "order": 56,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "工作設定：工時制度：主管機關命令調整？",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度|==|transformed_4w"
  },
  {
    "id": "工作設定：工時制度：主管機關命令調整？",
    "set": "",
    "order": 57,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "工作設定：工時制度：主管機關命令調整：公眾生活便利或其他特殊原因？",
    "set": "",
    "order": 58,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：工時制度：主管機關命令調整？|==|true"
  },
  {
    "id": "工作設定：班表：輪班制？",
    "set": "",
    "order": 59,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": ";工作設定：班表：休息（分鐘數，每連續四小時）;",
    "logic": "",
    "rule": ""
  },
  {
    "id": "工作設定：班表：輪班制：每週換班？",
    "set": "",
    "order": 60,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：班表：輪班制？|==|true"
  },
  {
    "id": "工作設定：班表：輪班制：勞工同意不每週換班？",
    "set": "",
    "order": 61,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：班表：輪班制？|==|true"
  },
  {
    "id": "工作設定：班表：輪班制：換班連續十一小時休息？",
    "set": "",
    "order": 62,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "工作設定：班表：輪班制？|==|true"
  },
  {
    "id": "工作設定：班表：休息（分鐘數，每連續四小時）",
    "set": "",
    "order": 63,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "工作設定：工作場所：坑內：非監視？",
    "set": "",
    "order": 64,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "report",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "個案：雇主終止勞動契約？",
    "set": "leave",
    "order": 65,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "個案：雇主終止勞動契約：預告（日數）;契約：競業禁止？;",
    "logic": "",
    "rule": ""
  },
  {
    "id": "個案：雇主終止勞動契約：預告（日數）",
    "set": "",
    "order": 66,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：雇主終止勞動契約？|==|true"
  },
  {
    "id": "個案：雇主終止勞動契約：給付預告期間工資？",
    "set": "",
    "order": 67,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：雇主終止勞動契約？|==|true"
  },
  {
    "id": "個案：雇主終止勞動契約：勞工另謀工作請假：時數（日數，每週）",
    "set": "",
    "order": 68,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：雇主終止勞動契約？|==|true"
  },
  {
    "id": "個案：雇主終止勞動契約：勞工另謀工作請假：工資照給？",
    "set": "",
    "order": 69,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：雇主終止勞動契約？|==|true"
  },
  {
    "id": "個案：雇主終止勞動契約：資遣費（金額）",
    "set": "",
    "order": 70,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：雇主終止勞動契約？|==|true"
  },
  {
    "id": "個案：雇主終止勞動契約：資遣費：終止到發給期間（日數）",
    "set": "",
    "order": 71,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：雇主終止勞動契約？|==|true"
  },
  {
    "id": "個案：當日：前六個月總日數（日數）",
    "set": "",
    "order": 72,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "個案：當日：前六個月工作日數（日數）",
    "set": "",
    "order": 73,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "個案：當日：前六個月工資總額（金額）",
    "set": "",
    "order": 74,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "個案：當日：平均工資（金額，每日）",
    "set": "",
    "order": 75,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "個案：當日：平均工資（金額，每月）",
    "set": "",
    "order": 76,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "個案：工作期間工作日數（日數）",
    "set": "",
    "order": 77,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "個案：工作期間工資總額（金額）",
    "set": "",
    "order": 78,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "個案：工作期間總日數（日數）",
    "set": "",
    "order": 79,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "契約：競業禁止？",
    "set": "",
    "order": 80,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": ";report;report",
    "logic": "",
    "rule": ""
  },
  {
    "id": "契約：競業禁止：勞工工作接觸營業秘密？",
    "set": "",
    "order": 81,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約：競業禁止？|==|true"
  },
  {
    "id": "契約：競業禁止：雇主有應受保護之正當營業利益？",
    "set": "",
    "order": 82,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約：競業禁止？|==|true"
  },
  {
    "id": "契約：競業禁止：期間（年數）",
    "set": "",
    "order": 83,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約：競業禁止？|==|true"
  },
  {
    "id": "契約：競業禁止：期間、區域、範圍、就業對象合理？",
    "set": "",
    "order": 84,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約：競業禁止？|==|true"
  },
  {
    "id": "契約：競業禁止：合理補償？",
    "set": "",
    "order": 85,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "契約：競業禁止？|==|true"
  },
  {
    "id": "契約：競業禁止：合理補償：包括工作給付？",
    "set": "",
    "order": 86,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "report",
    "route": "",
    "logic": "&&",
    "rule": "契約：競業禁止？|==|true;契約：競業禁止：合理補償？|==|true"
  },
  {
    "id": "工作性質：連續性或緊急性？",
    "set": "overtime",
    "order": 87,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "",
    "rule": ""
  },
  {
    "id": "個案：延長工作時間：突發？",
    "set": "",
    "order": 88,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": ";個案：延長工作時間：非突發：工會同意？;個案：延長工作時間：勞工正當理由不接受？",
    "logic": "",
    "rule": ""
  },
  {
    "id": "個案：延長工作時間：突發：假日種類",
    "set": "",
    "order": 89,
    "type": "select",
    "option": "holiday",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|true"
  },
  {
    "id": "個案：延長工作時間：突發：二十四小時內通知工會？",
    "set": "",
    "order": 90,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|true"
  },
  {
    "id": "個案：延長工作時間：突發：二十四小時內報當地主管機關？",
    "set": "",
    "order": 91,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|true"
  },
  {
    "id": "個案：延長工作時間：突發（時數）",
    "set": "",
    "order": 92,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|true"
  },
  {
    "id": "個案：延長工作時間：突發：事後補休？",
    "set": "",
    "order": 93,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|true"
  },
  {
    "id": "個案：延長工作時間：突發：工資（金額，每小時）",
    "set": "",
    "order": 94,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "個案：延長工作時間：勞工正當理由不接受？",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|true"
  },
  {
    "id": "個案：延長工作時間：非突發：工會同意？",
    "set": "",
    "order": 95,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false"
  },
  {
    "id": "個案：延長工作時間：非突發：勞資會議同意？",
    "set": "",
    "order": 96,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false"
  },
  {
    "id": "個案：延長工作時間：非突發：總工作時間（時數，每日）",
    "set": "",
    "order": 97,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false"
  },
  {
    "id": "個案：延長工作時間：非突發：總延長工作時間（時數，每月）",
    "set": "",
    "order": 98,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false"
  },
  {
    "id": "個案：延長工作時間：非突發：平日？",
    "set": "",
    "order": 99,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false"
  },
  {
    "id": "個案：延長工作時間：非突發：平日（時數）",
    "set": "",
    "order": 100,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false;個案：延長工作時間：非突發：平日？|==|true"
  },
  {
    "id": "個案：延長工作時間：非突發：平日：工資（金額）",
    "set": "",
    "order": 101,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false;個案：延長工作時間：非突發：平日？|==|true"
  },
  {
    "id": "個案：延長工作時間：非突發：平日：四週變形（時數，每日）",
    "set": "",
    "order": 102,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false;個案：延長工作時間：非突發：平日？|==|true"
  },
  {
    "id": "個案：延長工作時間：非突發：休息日？",
    "set": "",
    "order": 103,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false"
  },
  {
    "id": "個案：延長工作時間：非突發：休息日（時數）",
    "set": "",
    "order": 104,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false;個案：延長工作時間：非突發：休息日？|==|true"
  },
  {
    "id": "個案：延長工作時間：非突發：休息日：工資（金額）",
    "set": "",
    "order": 105,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false;個案：延長工作時間：非突發：休息日？|==|true"
  },
  {
    "id": "個案：延長工作時間：非突發：國定假日？",
    "set": "",
    "order": 106,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false"
  },
  {
    "id": "個案：延長工作時間：非突發：國定假日：勞工同意？",
    "set": "",
    "order": 107,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false;個案：延長工作時間：非突發：國定假日？|==|true"
  },
  {
    "id": "個案：延長工作時間：非突發：國定假日：工資（金額，每小時）",
    "set": "",
    "order": 108,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false;個案：延長工作時間：非突發：國定假日？|==|true"
  },
  {
    "id": "個案：延長工作時間：非突發：特別休假日？",
    "set": "",
    "order": 109,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false"
  },
  {
    "id": "個案：延長工作時間：非突發：特別休假日：勞工同意？",
    "set": "",
    "order": 110,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false;個案：延長工作時間：非突發：特別休假日？|==|true"
  },
  {
    "id": "個案：延長工作時間：非突發：特別休假日：主管機關認有必要？",
    "set": "",
    "order": 111,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false;個案：延長工作時間：非突發：特別休假日？|==|true"
  },
  {
    "id": "個案：延長工作時間：非突發：特別休假日：工資（金額，每小時）",
    "set": "",
    "order": 112,
    "type": "input",
    "option": "",
    "title": "",
    "description": "",
    "next": "",
    "route": "",
    "logic": "&&",
    "rule": "個案：延長工作時間：突發？|==|false;個案：延長工作時間：非突發：特別休假日？|==|true"
  },
  {
    "id": "個案：延長工作時間：勞工正當理由不接受？",
    "set": "",
    "order": 113,
    "type": "select",
    "option": "boolean",
    "title": "",
    "description": "",
    "next": "report",
    "route": "",
    "logic": "",
    "rule": ""
  }
]



// WEBPACK FOOTER //
// ./src/data/QuizData.js